var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.className == 'reverse' ? _c('div', {
    class: _vm.className + ' border overwiew-item'
  }, [_c('v-row', {
    staticClass: "flex-column-reverse flex-lg-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "w-100 h-100 pa-20 pa-md-30 py-lg-16 px-xl-50 d-flex flex-column justify-center icon-box text-lg-right"
  }, [_c('div', {
    staticClass: "d-flex d-lg-block justify-end"
  }, [_c('v-img', {
    staticClass: "icon-box-icon mb-6 mb-lg-0",
    attrs: {
      "src": _vm.icon,
      "max-width": _vm.iconWidth
    }
  })], 1), _c('p', {
    staticClass: "color-point font-size-12 font-size-lg-16 line-height-1 mb-2 mb-lg-14"
  }, [_vm._v(" " + _vm._s(_vm.num) + " ")]), _c('h5', {
    staticClass: "tit--sm font-weight-medium mb-10 mb-lg-18"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _c('p', {
    staticClass: "color-grey-2c font-size-14 font-size-lg-16"
  }, [_vm._t("default")], 2)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.src
    }
  })], 1)], 1)], 1) : _c('div', {
    staticClass: "border overwiew-item"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.src
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "w-100 h-100 pa-20 pa-md-30 py-lg-16 px-xl-50 d-flex flex-column justify-center icon-box"
  }, [_c('div', {
    staticClass: "d-flex d-lg-block justify-end"
  }, [_c('v-img', {
    staticClass: "icon-box-icon mb-6 mb-lg-0",
    attrs: {
      "src": _vm.icon,
      "max-width": _vm.iconWidth
    }
  })], 1), _c('p', {
    staticClass: "color-point font-size-12 font-size-lg-16 line-height-1 mb-2 mb-lg-14"
  }, [_vm._v(" " + _vm._s(_vm.num) + " ")]), _c('h5', {
    staticClass: "tit--sm font-weight-medium mb-10 mb-lg-18"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _c('p', {
    staticClass: "color-grey-2c font-size-14 font-size-lg-16"
  }, [_vm._t("default")], 2)])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }